import { make } from 'vuex-pathify'
import state from './state'
import firebase from 'firebase/app'

export default {
  ...make.actions(state),

  autoSignIn ({ commit }, user) {
    commit('SET_USER', user)
    commit('SET_LOADING', false)
  },
  logout ({ commit }) {
    commit('SET_LOADING', true)
    firebase.auth().signOut()
      .then(function () {
        commit('SET_USER', {})
        commit('SET_LOADING', false)
      })
      .catch(error => {
        commit('SET_ERROR', error.message)
        commit('SET_LOADING', false)
      })
  }
}
